export default __webpack_public_path__ + "static/media/7.c9f5d0d5.png";